import { ActivityEventProcessType } from '@warebee/shared/import-converter';

export const shippingKpis /*: WarehouseKPI[] */ = [
  {
    id: 'shipping_accuracy',
    processType: ActivityEventProcessType.SHIPPING,
    category: 'process',
    title: 'Shipping Accuracy',
    description:
      'Percentage of orders shipped with correct items, quantities, and destination',
    unit: '%',
    formula: '(1 - (COUNT(shipping_exceptions) / COUNT(shipped_orders))) * 100',
    tags: ['shipping', 'quality'],
    benchmark: {
      standards: {
        site: {
          target: 99.9,
          warning: { lower: 99.5 },
          critical: { lower: 99 },
          basis: 'Legacy benchmark migrated',
        },
      },
      primarySource: 'site',
      timeWindows: [
        {
          name: 'default',
          duration: 'P28D',
          thresholdType: 'static',
          ranges: [
            { label: 'Critical', min: 0, max: 99 },
            { label: 'Warning', min: 99.01, max: 99.5 },
            { label: 'Target', min: 99.51, max: 99.9 },
          ],
        },
      ],
      metadata: { source: 'baseline' },
    },
    trendWindow: 'P28D',
    drillDimensions: ['shipper_id', 'carrier', 'destination_zone'],
    alertTopic: 'warehouse.alerts.process.shipping_accuracy',
  },
];

export default shippingKpis;
